<template>
    <div id="normalCardRoot">

    </div>
</template>

<script>
	export default {
		name: "NormalCard"
	}
</script>

<style lang="scss" src="../styles/normalcard.scss" scoped/>